import React, { useEffect, useState } from 'react';

import { LOGOUT } from 'ConstComponents';

import { useHistory } from 'react-router';

import { ActiveCreditCard as CREDITCARD_ACTIVE } from 'Components/Api/CreditCardSettingAPI';

import { Container, Grid, Paper } from '@material-ui/core';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';

import HOCLoader from 'Components/Loader/HOCLoader';

const CustomContainer = HOCLoader(Container);

export const Index = () => {
    const history = useHistory();

    const classes = commonStyle();
    const [severity, setSeverity] = useState('success');
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);

    const selectActiveCreditCard = async () => {
        const response = await CREDITCARD_ACTIVE();

        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }
        let data = JSON.parse(response.data);

        let name = data.Name.toLowerCase();
        if (data.IsCommonCreditCard === true) {
            let param = {
                CreditCardName: name
            };
            history.push('/C_CreditCardPayment', param);
            return;
        }

        if (name.toLowerCase() === 'Paysprint'.toLowerCase()) {
            history.push('/PCreditCardPayment');
            return;
        } else if (name.toLowerCase() === 'PayU'.toLowerCase()) {
            history.push('/PUCreditCardPayment');
            return;
        } else if (name.toLowerCase() === 'CashFree'.toLowerCase()) {
            history.push('/CFCreditCardPayment');
            return;
        } else if (name.toLowerCase() === 'Mobikwik'.toLowerCase()) {
            history.push('/MkCreditCardPayment');
            return;
        } else if (name.toLowerCase() === 'InstantPay'.toLowerCase()) {
            history.push('/IPCreditCardPayment');
            return;
        }
    };

    useEffect(() => {
        selectActiveCreditCard();
    }, []);

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Paper className={classes.PaperStyle}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        Please wait
                    </Grid>
                </Grid>
            </Paper>
        </CustomContainer>
    );
};
